import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ApplicationError = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Submission Failed | VisionBird</title>
        <meta
          name="description"
          content="We're sorry — your application could not be submitted at this time. Please try again later."
        />
      </Helmet>

      <Navbar />

      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #fff5f5 0%, #ffffff 60%, #fff0f0 100%)",
        padding: "60px 20px",
      }}>
        <div style={{
          maxWidth: "540px",
          width: "100%",
          textAlign: "center",
          animation: "fadeInUp 0.6s ease both",
        }}>

          {/* Icon */}
          <div style={{
            width: "96px",
            height: "96px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #e53e3e, #c53030)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 32px",
            boxShadow: "0 16px 40px rgba(229, 62, 62, 0.28)",
          }}>
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          {/* Heading */}
          <h1 style={{
            fontSize: "clamp(24px, 5vw, 34px)",
            fontWeight: 800,
            color: "#111",
            margin: "0 0 14px",
            lineHeight: 1.2,
            fontFamily: "'Segoe UI', sans-serif",
          }}>
            Submission Failed
          </h1>

          {/* Message */}
          <p style={{
            fontSize: "16px",
            color: "#555",
            lineHeight: 1.8,
            margin: "0 0 10px",
            fontFamily: "'Segoe UI', sans-serif",
          }}>
            We're sorry — something went wrong while submitting your application. Your information was not saved.
          </p>

          <p style={{
            fontSize: "15px",
            color: "#777",
            lineHeight: 1.8,
            margin: "0 0 36px",
            fontFamily: "'Segoe UI', sans-serif",
          }}>
            This is usually a temporary issue. Please check your internet connection and try again. If the problem persists, feel free to contact us directly.
          </p>

          {/* Action buttons */}
          <div style={{ display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                display: "inline-block",
                background: "linear-gradient(135deg, #e53e3e, #c53030)",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                padding: "14px 36px",
                borderRadius: "50px",
                fontWeight: 700,
                fontSize: "15px",
                fontFamily: "'Segoe UI', sans-serif",
                boxShadow: "0 8px 24px rgba(229,62,62,0.3)",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 12px 30px rgba(229,62,62,0.4)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(229,62,62,0.3)"; }}
            >
              Try Again
            </button>

            <Link
              to="/Contact"
              style={{
                display: "inline-block",
                background: "transparent",
                color: "#444",
                textDecoration: "none",
                padding: "14px 36px",
                borderRadius: "50px",
                fontWeight: 700,
                fontSize: "15px",
                fontFamily: "'Segoe UI', sans-serif",
                border: "1.5px solid #ddd",
                transition: "border-color 0.2s ease, color 0.2s ease",
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "#aaa"; e.currentTarget.style.color = "#111"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "#ddd"; e.currentTarget.style.color = "#444"; }}
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default ApplicationError;
